import { TableColumn } from '../../../../components/ModularDataTable/types'
import type { Feature } from '../types'

const segmentLabelMap: Record<string, string> = {
    fashion: 'Moda',
    general: 'Geral',
    food: 'Alimentacao',
    varejo: 'Varejo',
    hospitality: 'Hospitalidade',
}

function SegmentTableFeature({ row }: { row: Feature }) {
    const label = segmentLabelMap[row.segmentType] || row.segmentType

    return (
        <span className='badge badge-light-primary fw-bold px-3 py-2'>
            {label}
        </span>
    )
}

export function generateColumnsFeatureSpace(): TableColumn[] {
    return [
        { key: 'Id', value: 'id', type: 'text', width: '80px' },
        { key: 'Nome', value: 'name', type: 'text' },
        { key: 'Codigo', value: 'code', type: 'text' },
        {
            key: 'Segmento',
            value: 'segmentType',
            type: 'custom',
            render: (_value: unknown, row: Feature) => <SegmentTableFeature row={row} />,
        },
        { key: 'Descricao', value: 'description', type: 'text' },
    ]
}